import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from '../../../shared/models/plans';
import { Router } from '@angular/router';
import * as planUtils from '../../../shared/plan/planUtils';
import { isMonthlyPlan } from '../../../shared/utils/planUtils';

@Component({
  selector: 'cc-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss']
})
export class CurrentPlanComponent implements OnInit {
  @Input() subscription: Subscription;
  public isTrial = true;
  public planRemainingTime = '';
  public addonsAvailable = false;
  public subscriptionExpired = false;

  constructor(private router: Router) {}

  ngOnInit() {
    this.isTrial = this.subscription ? this.subscription.status === 'TRIAL' : true;
    this.planRemainingTime = planUtils.formatPlanRemainingTime(this.subscription);
    this.subscriptionExpired = planUtils.subscriptionExpired(this.subscription);
  }

  public changePlan() {
    this.router.navigate(['choose-plan']);
  }

  get totalPrice() {
    if (!this.subscription || !this.subscription.licenses || !this.subscription.licenses.length) {
      return 0;
    }

    const subscriptionLicense = this.subscription.licenses[0];
    const addonLicenses = this.subscription.addonLicenses;
    const planPrice = subscriptionLicense.planPriceCents;
    const addonPrice = addonLicenses && addonLicenses.length ? addonLicenses[0].priceCents : 0;
    const planTotalPriceForPeriod = planPrice / 100;
    const addonTotalPriceForPeriod = addonPrice / 100;

    return planTotalPriceForPeriod + addonTotalPriceForPeriod;
  }

  public currentSubscriptionPrice(): number {
    if (!this.subscription) {
      return 0;
    }
    const currentPlan = this.subscription.licenses[0];
    const { interval, planPriceCents } = currentPlan;
    const planPriceDollars = planPriceCents / 100;

    return isMonthlyPlan(interval) ? planPriceDollars : Math.round(planPriceDollars / 12);
  }
}
